import { render, staticRenderFns } from "./ReportContractsChatbotNoConsumption.vue?vue&type=template&id=70db8a10"
import script from "./ReportContractsChatbotNoConsumption.vue?vue&type=script&lang=js"
export * from "./ReportContractsChatbotNoConsumption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports